export default __webpack_public_path__ + "static/media/Abyssal Demon Ring of Constitution.7b76cd80.jpg";